import styles from "./HistorialServicioTecCambioDom.module.css";
import { useState, useEffect, useContext } from "react";
import {
  Col,
  Row,
  Container,
  Button,
  Modal,
  Card,
  Collapse,
} from "react-bootstrap";
import exclamation from "../../../src/assets/img/Reportes/exclamation-circle.png";
import { FiChevronDown } from "react-icons/fi";
import Loading from "../../General/Loading";
import { Paginacion } from "../../Commons/paginacion/Paginacion";

import {
  builtGetReportesEntrada,
  GetReportes_Entrada,
  GetReportes_Parametros,
  GetReportes_Respuesta,
} from "../../Commons/Services/GetReportes";

import {
  DetalleSolicitudDeServicio,
  ConsultaSolicitudDeServicio_Respuesta,
  ConsultaSolicitudDeServicio_Parametros,
  builtRecargaConsultaPrecioRecargaInput,
  ConsultaSolicitudDeServicio_Entrada,
} from "../../Commons/Services/ConsultaSolicitudDeServicioRest";
import { ConsultaWS } from "../../Commons/ServiciosBase";
import { isNull } from "util";
import ContextFlujos from "../../Context/ContextFlujos";

const HistorialServicioTecCambioDom = () => {
  const [myLocalArray, setMyLocalArray] = useState<
    DetalleSolicitudDeServicio[]
  >([]);
  let flagArray: boolean[] = [];


  const [flags, setFlag] = useState(flagArray);
  const [flag, refreshFlags] = useState(false);
  const [loading, isLoading] = useState(false);
  const [solicitudesPorPagina, setSolicitudesPorPagina] = useState(5);
  const [paginaActual, setPaginaActual] = useState(1);


  const totalSolicitudes = myLocalArray.length;

  const ultimoIndice = paginaActual * solicitudesPorPagina;
  const primerIndice = ultimoIndice - solicitudesPorPagina;


  function handleReporte(id: number) {
    flags[id] = !flags[id];
    setFlag(flags);
    refreshFlags(!flag);
  }



  const doConsultaSolicitudDeServicio = async () => {
    isLoading(true);
    //----------------------------------------------------------------------------------------------------------------------------
    const ConsultaSolicitudDeServicioDO: ConsultaSolicitudDeServicio_Entrada =
      builtRecargaConsultaPrecioRecargaInput(
        `${sessionStorage.getItem("rowId")}`,
        "Reparaciones",
        "Servicio Web"
      );
    let par = ConsultaSolicitudDeServicio_Parametros(
      ConsultaSolicitudDeServicioDO
    );

    let respuesta: ConsultaSolicitudDeServicio_Respuesta = await ConsultaWS(
      par
    );

    if (
      typeof respuesta.ConsultaSolicitudDeServicioProcessResponse
        .DetalleSolicitudDeServicio != "undefined"
    ) {
      const res =
        respuesta.ConsultaSolicitudDeServicioProcessResponse
          .DetalleSolicitudDeServicio;

      const temp = res.map((e, i) => ({ ...e, id: i }));
      setMyLocalArray(temp.map((e) => ({ ...e, isOpen: false })));
    } else {
      setMyLocalArray([]);
    }
    isLoading(false);
    //----------------------------------------------------------------------------------------------------------------------------
  };


  useEffect(() => {
    doConsultaSolicitudDeServicio();
  }, []);


  function formatDate(strDate: any) {
    if (strDate) {

      let dateArray = strDate.substring(0, 10).split("/");

      return dateArray[0] + "/" + dateArray[1] + "/" + dateArray[2];
    }

    return strDate;
  }



  if (myLocalArray.length > 0) {

    return (
      <>
        <Loading isLoading={loading} />
        <Container fluid className={styles["container"]}>
          <Row className={styles["subheaderRowGrid"]}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <p className={styles["title"]}>Tu historial de solicitudes</p>
            </Col>
          </Row>
        </Container>
        <div id="bigGrid"
          className={"d-none d-sm-block d-md-block d-lg-block d-xl-block"}        >
          <Container fluid className={styles["subheaderRowGrid"] + " " + styles["historialGrid"]}>
            <Row className={styles["subheaderRowGrid"] + " " + styles["gridHeader"]}>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                <span>Fecha</span>
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <span>No. de caso</span>
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                <span>Descripción</span>
              </Col>
            </Row>
            {myLocalArray
              .map((data, index) => (
                <Row className={styles["subheaderRowGrid"] + " " + styles["grid"]} key={"bigRow_" + index}                >
                  <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                    <span>{formatDate(data.FechaCreacion)}</span>
                  </Col>
                  <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                    <span>{data.NumeroDeSolicitud}</span>
                  </Col>
                  <Col xs={4} sm={4} md={4} lg={4} xl={4} className={styles["alignToLeft"]}                  >
                    <span>{data.Comentario == null ? "Sin comentario" : data.Comentario}</span>
                  </Col>

                </Row>
              ))
              .slice(primerIndice, ultimoIndice)}
          </Container>
          <Container
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "100px",
            }}
          >
            <Paginacion
              itemsPorPagina={solicitudesPorPagina}
              pageActual={paginaActual}
              setPageActual={setPaginaActual}
              itemsTotal={totalSolicitudes}
            />
          </Container>
        </div>

        <div id="smallGrid" className={"d-sm-none d-md-none d-lg-none d-xl-none"}>
          {myLocalArray.map((data, index) => (
            <Row className={styles["aclararionRow"]} key={"smallRow_" + index}>
              <Col
                className={styles["smallColMargin"]}
                xs={12}
                sm={12}
                md={6}
                lg={4}
                xl={3}
              >
                <Card className={styles["reporteCard"]}>
                  <Card.Body className={styles["cardContainer"]}>
                    <Row className={styles["titleContainer"]}>
                      <Col
                        className={styles["titleCol"]}
                        xs={8}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                      >
                        <p
                          className={
                            !flags[index]
                              ? styles["titleCard"]
                              : styles["titleCard"] +
                              " " +
                              styles["titleCardOpenMargin"]
                          }
                        >
                          <span className={styles["paqueteAlign"]}>
                            {formatDate(data.FechaCreacion)}
                          </span>
                        </p>
                      </Col>
                      <Col
                        className={styles["buttonCol"]}
                        xs={4}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                      >
                        <FiChevronDown
                          className={
                            !flags[index]
                              ? styles["iconArrowDown"]
                              : styles["iconArrowUp"]
                          }
                          onClick={() => handleReporte(index)}
                        />
                      </Col>
                    </Row>
                    <Row className={styles["textContainer"]}>
                      <Collapse in={!!flags[index]}>
                        <Container fluid>
                          <Row>
                            <Col>
                              <p
                                className={
                                  styles["listCardTitle"] +
                                  " " +
                                  styles["topList"]
                                }
                              >
                                Fecha
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <p className={styles["listCardDesc"]}>
                                {formatDate(data.FechaCreacion)}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <p className={styles["listCardTitle"]}>
                                No. de caso
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <p className={styles["listCardDesc"]}>
                                {data.NumeroDeSolicitud}
                              </p>
                            </Col>
                          </Row>

                          <Row>
                            <Col>
                              <p className={styles["listCardDesc"]}>
                                {data.Comentario == null ? "Sin comentario" : data.Comentario}
                              </p>
                            </Col>
                          </Row>
                        </Container>
                      </Collapse>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          ))}
        </div>

      </>
    );


  } else {

    return (
      <>
        <Container fluid className={styles["contenedorNoHistorial"]}>
          <Row className={styles["subheaderRowGridNoHistorial"]}>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <p className={styles["titleNoHistorial"]}>
                Tu historial de solicitudes
              </p>
            </Col>
          </Row>
          <div className={styles["avisoNoHistorial"]}>
            <p className={styles["avisoTituloNoHistorial"]}>
              Parece que aún no has hecho ninguna solicitud
            </p>
            <p className={styles["avisoTextoNoHistorial"]}>
              Cuando realices una solicitud podrás visualizarlo aquí
            </p>
          </div>
        </Container>
      </>
    );

  }






}

export default HistorialServicioTecCambioDom;
